import {Component, OnInit} from '@angular/core';
import {PageService} from "../shared/layout/services/page.service";

@Component({
  selector: 'app-feito-conferido',
  templateUrl: './feito-conferido.component.html',
  styleUrls: ['./feito-conferido.component.scss']
})
export class FeitoConferidoComponent implements OnInit {

  constructor(private page: PageService) {
  }

  ngOnInit() {
    this.page.defineTitle('FEITO / CONFERIDO');
  }

}
